var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckSymbol(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12,3.51C7.43,3.51,3.71,7.32,3.71,12s3.72,8.48,8.29,8.48,8.29-3.81,8.29-8.48S16.57,3.51,12,3.51Zm0,15.47c-3.74,0-6.79-3.13-6.79-6.98s3.05-6.99,6.79-6.99,6.79,3.14,6.79,6.99-3.05,6.98-6.79,6.98Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12,6.58c-2.94,0-5.34,2.41-5.34,5.41s2.4,5.41,5.34,5.41,5.34-2.41,5.34-5.41-2.4-5.41-5.34-5.41Zm-.78,9.32l-3.33-3.33,1.06-1.06,2.07,2.06,3.31-4.74,1.23,.85-4.34,6.22Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSymbol);
export default __webpack_public_path__ + "static/media/Check-Symbol.c732c2198ddaa420c256d59cc33956fd.svg";
export { ForwardRef as ReactComponent };